exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clothing-admin__section {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__section-title {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.clothing-admin__section-note {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__field {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__field label {\r\n  display: block;\r\n  font-weight: 600;\r\n  min-height: 2.5rem;\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.clothing-admin__field--checkbox {\r\n  -webkit-box-align: end;\r\n      -ms-flex-align: end;\r\n          align-items: flex-end;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.clothing-admin__checkbox {\r\n  font-weight: 600;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.clothing-admin__save-button {\r\n  min-width: 12rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-settings-form.component.css
// module id = ../../../../../src/app/content-page/admin/clothing/clothing-admin-settings-form.component.css
// module chunks = main